export default {
  cloudNativeRow1: '杰为平台使用容器包的微服务构建，除了拥有基于云的基础优势，如降低成本、可扩展性及对数据和数字化链的集中访问，还可以独立部署管理每一个服务。通过DevOps自动化，无需停机自动更新，公私有云或者混合云环境里均可部署。'
}
